(function () {
  'use strict';

  const STORE_KEY = '__taraConsultationResultsStore';

  function getDocumentLocale() {
    return (document.documentElement.lang || '').toString().trim().toLowerCase() || '';
  }

  function buildMonitoringMeta(meta) {
    return {
      route: meta.route || window.location.pathname || '/pages/consultation-results',
      level: meta.level,
      error_code: meta.error_code || meta.errorCode || '',
      status_code: meta.status_code != null ? meta.status_code : meta.statusCode,
      request_duration_ms: meta.request_duration_ms != null ? meta.request_duration_ms : meta.durationMs,
      fingerprint: meta.fingerprint,
      tags: Object.assign({
        locale: getDocumentLocale() || undefined,
      }, (meta.tags && typeof meta.tags === 'object') ? meta.tags : {}),
      extra: Object.assign({
        section_id: meta.sectionId || undefined,
        worker_error: meta.worker_error || meta.workerError || undefined,
      }, (meta.extra && typeof meta.extra === 'object') ? meta.extra : {}),
    };
  }

  function captureMonitoringException(error, meta) {
    const monitoring = window.TaraConsultationMonitoring || null;
    if (!monitoring || !error) return;
    monitoring.captureException(error, buildMonitoringMeta(meta || {}));
  }

  function captureMonitoringMessage(message, meta) {
    const monitoring = window.TaraConsultationMonitoring || null;
    if (!monitoring || !message) return;
    monitoring.captureMessage(message, buildMonitoringMeta(meta || {}));
  }

  function getOrCreateStore() {
    if (window[STORE_KEY]) return window[STORE_KEY];

    const cartHelpers = window.TaraConsultationResultsCart
      ? window.TaraConsultationResultsCart.createHelpers({
        getState: function getState(sectionId) {
          return store.getState(sectionId);
        },
      })
      : null;

    const store = {
      activeSectionId: null,
      states: {},
      setState(sectionId, state) {
        this.activeSectionId = sectionId;
        this.states[sectionId] = state;
      },
      getState(sectionId) {
        const targetId = sectionId || this.activeSectionId;
        return targetId ? this.states[targetId] || null : null;
      },
      getHelpers() {
        return cartHelpers;
      },
    };

    window[STORE_KEY] = store;
    return store;
  }

  function decodeHtmlEntities(value) {
    if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function decodeI18nMap(i18n) {
    if (!i18n || typeof i18n !== 'object') return i18n || {};
    return Object.entries(i18n).reduce(function decodeMap(output, entry) {
      output[entry[0]] = decodeHtmlEntities(entry[1]);
      return output;
    }, {});
  }

  function publishState(sectionId, state) {
    const store = getOrCreateStore();
    store.setState(sectionId, state);

    const eventName = state.empty ? 'tara:consultation-data-empty' : 'tara:consultation-data-ready';
    document.dispatchEvent(new CustomEvent(eventName, { detail: { sectionId, state } }));
    document.dispatchEvent(new CustomEvent(`${eventName}:${sectionId}`, { detail: state }));
  }

  const DESIGN_MODE_PRODUCT_HANDLES = Object.freeze([
    'charcoal-salicylic-exfoliating-shampoo',
    'ghassoul-avocado-smoothing-conditioner',
    'cactus-red-seaweed-scalp-serum',
  ]);

  const DESIGN_MODE_BUNDLE_HANDLE = 'scalp-hair-revival-system';

  function getCatalogHandleSet(catalogArr) {
    return new Set(
      (Array.isArray(catalogArr) ? catalogArr : [])
        .map(function mapHandle(product) {
          return product && product.handle ? String(product.handle).trim() : '';
        })
        .filter(Boolean)
    );
  }

  function pickDesignModeProductHandles(catalogArr) {
    const handles = getCatalogHandleSet(catalogArr);
    const picked = DESIGN_MODE_PRODUCT_HANDLES.filter(function filterPreferred(handle) {
      return handles.has(handle);
    });

    if (picked.length >= 3) return picked.slice(0, 3);

    (Array.isArray(catalogArr) ? catalogArr : []).forEach(function addCatalogProduct(product) {
      const handle = product && product.handle ? String(product.handle).trim() : '';
      if (!handle || picked.includes(handle)) return;
      if (handle.indexOf('-system') !== -1) return;
      if (Array.isArray(product.tags) && product.tags.includes('Sets')) return;
      picked.push(handle);
    });

    return (picked.length ? picked : DESIGN_MODE_PRODUCT_HANDLES).slice(0, 3);
  }

  function buildDesignModeRecommendations(handles, isAr) {
    const arSteps = ['تنقية فروة الرأس', 'ترطيب الأطوال', 'تهدئة الفروة'];
    const enSteps = ['Clarify the scalp', 'Condition the lengths', 'Support the scalp'];
    const arReasons = [
      'يساعد على إزالة التراكم من دون تحويل المعاينة إلى نتيجة حقيقية للعميل.',
      'يعيد نعومة الأطوال بعد خطوة التنظيف حتى يظهر تصميم بطاقة المنتج بوضوح.',
      'يظهر دور خطوة العناية بفروة الرأس داخل الروتين الكامل.',
    ];
    const enReasons = [
      'Shows how the results page explains the first cleansing step.',
      'Shows how the routine card explains conditioning and softness.',
      'Shows how the serum step is positioned inside the complete routine.',
    ];

    return handles.map(function mapHandle(handle, index) {
      return {
        handle,
        step_label: (isAr ? arSteps : enSteps)[index] || (isAr ? 'خطوة في الروتين' : 'Routine step'),
        reasoning: (isAr ? arReasons : enReasons)[index] || '',
        hero: index === 0,
      };
    });
  }

  function getDesignModeSampleResult(catalogArr, config) {
    const isAr = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
    const handles = pickDesignModeProductHandles(catalogArr);
    const catalogHandles = getCatalogHandleSet(catalogArr);
    const hasBundle = catalogHandles.has(DESIGN_MODE_BUNDLE_HANDLE);
    const mode = hasBundle ? 'bundle_product' : 'multi_item';
    const routineItems = mode === 'bundle_product'
      ? [{ handle: DESIGN_MODE_BUNDLE_HANDLE, quantity: 1 }]
      : handles.map(function mapItem(handle) {
        return { handle, quantity: 1 };
      });
    const configuredOffer = config && config.offer && typeof config.offer === 'object' ? config.offer : {};
    const previewDiscountPercent = Number(configuredOffer.fullSetDiscountPercent) || 0;
    const previewCurrency = String(config && config.currency || 'EUR').trim().toUpperCase();
    const previewReferencePrice = 100;
    const previewDiscountedPrice = previewDiscountPercent > 0
      ? Number((previewReferencePrice * (100 - previewDiscountPercent) / 100).toFixed(2))
      : previewReferencePrice;
    const previewSavings = Number((previewReferencePrice - previewDiscountedPrice).toFixed(2));
    const offerRequiredHandles = mode === 'bundle_product' ? [DESIGN_MODE_BUNDLE_HANDLE] : handles;
    const recommendations = buildDesignModeRecommendations(handles, isAr);
    const expiresAt = new Date(Date.now() + (7 * 86400000)).toISOString();

    if (isAr) {
      return {
        assessment_id: 'theme-editor-preview',
        result_url: '/results/theme-editor-preview',
        concern_level: 'moderate',
        care_priority: 'ابدئي بتنظيم فروة الرأس ثم أعيدي بناء التوازن اليومي للأطوال.',
        assessment_headline: 'معاينة نتيجة الاستشارة',
        assessment_summary: 'هذا محتوى معاينة يظهر فقط داخل محرر القالب حتى يمكن ترتيب الصفحة وتعديل أقسامها. العملاء يرون النتيجة الحقيقية المحفوظة من العامل بعد إكمال الاستشارة.',
        what_is_happening: 'توضح المعاينة كيف يظهر شرح التشخيص قبل عرض الروتين والمنتجات المقترحة.',
        key_insight: 'الهدف هنا هو معاينة ترتيب الصفحة، وليس إنشاء تشخيص حقيقي.',
        why_previous_products_underperformed: 'قد تبدو المنتجات السابقة غير كافية عندما لا يعالج الروتين الفروة والأطوال معاً.',
        how_tara_works_for_you: 'تجمع تارا بين خطوات تنظيف الفروة ودعمها وترطيب الأطوال ضمن روتين واحد واضح.',
        why_this_routine_not_others: 'هذا المثال يوضح شكل روتين كامل مع بطاقة عرض وكود خصم ومنتجات منفردة.',
        purchase_nudge: 'يمكن تعديل ترتيب هذا القسم ومظهره من محرر القالب.',
        recommended_products: recommendations,
        routine_purchase_option: {
          mode,
          bundle_handle: mode === 'bundle_product' ? DESIGN_MODE_BUNDLE_HANDLE : '',
          title: 'روتين معاينة كامل',
          subtitle: 'مثال قابل للتعديل داخل محرر القالب فقط',
          reasoning: 'يعرض هذا المثال كيف يظهر عرض الروتين الكامل مع الكود وزر الإضافة.',
          button_label: 'أضيفي الروتين إلى السلة',
          product_handles: handles,
          items: routineItems,
          },
          offer: {
            mode,
            active: true,
          discount_percent: previewDiscountPercent,
          currency: previewCurrency,
          reference_price: previewReferencePrice,
          discounted_price: previewDiscountedPrice,
          savings: previewSavings,
          required_handles: offerRequiredHandles,
          bundle_handle: mode === 'bundle_product' ? DESIGN_MODE_BUNDLE_HANDLE : '',
          max_sets: 1,
          expires_at: expiresAt,
          activation: {
            status: 'active',
            code: 'TARA-PREVIEW',
            expires_at: expiresAt,
          },
        },
        care_protocol: {
          entry_point: 'full_routine',
          intensive_phase: 'استخدمي الروتين كاملاً خلال الأسابيع الأولى كما يظهر في المعاينة.',
          maintenance_phase: 'بعد ذلك يمكن الحفاظ على الخطوات الأساسية بحسب الحاجة.',
          expected_timeline: 'تظهر هذه العبارة موضع توقعات النتائج في التصميم.',
          personalized_note: 'هذه نسخة تحريرية للمعاينة فقط ولا تظهر كبديل عن نتيجة العميل.',
        },
        ingredient_highlights: [
          { name: 'Niacinamide', benefit: 'يدعم مظهر فروة رأس أكثر توازناً.' },
          { name: 'Salicylic Acid', benefit: 'يساعد على إبراز بطاقة مكوّن خاص بتنقية الفروة.' },
          { name: 'Cactus Extract', benefit: 'يوضح مكان فائدة المكوّن داخل بطاقة المعاينة.' },
        ],
      };
    }

    return {
      assessment_id: 'theme-editor-preview',
      result_url: '/results/theme-editor-preview',
      concern_level: 'moderate',
      care_priority: 'Start by calming the scalp, then rebuild day-to-day balance through the lengths.',
      assessment_headline: 'Consultation result preview',
      assessment_summary: 'This preview appears only inside the theme editor so you can arrange and style the results page. Live customers see the real saved worker assessment from their completed consultation.',
      what_is_happening: 'The preview shows how diagnostic explanation appears before the routine, offer, products, and ingredient sections.',
      key_insight: 'Use this preview to edit layout and styling, not as customer diagnosis content.',
      why_previous_products_underperformed: 'Previous routines can feel incomplete when they treat the hair fiber without addressing the scalp environment.',
      how_tara_works_for_you: 'Tara connects scalp care, conditioning, and targeted support into one complete routine.',
      why_this_routine_not_others: 'This sample demonstrates a full routine with an offer, cart CTA, individual product cards, and ingredient highlights.',
      purchase_nudge: 'You can adjust this section order and spacing from the theme editor.',
      recommended_products: recommendations,
      routine_purchase_option: {
        mode,
        bundle_handle: mode === 'bundle_product' ? DESIGN_MODE_BUNDLE_HANDLE : '',
        title: 'Complete preview routine',
        subtitle: 'Theme-editor sample only',
        reasoning: 'This sample shows how the full-routine offer, code, and add-to-cart action render.',
        button_label: 'Add routine to cart',
        product_handles: handles,
        items: routineItems,
      },
      offer: {
        mode,
        active: true,
        discount_percent: previewDiscountPercent,
        currency: previewCurrency,
        reference_price: previewReferencePrice,
        discounted_price: previewDiscountedPrice,
        savings: previewSavings,
        required_handles: offerRequiredHandles,
        bundle_handle: mode === 'bundle_product' ? DESIGN_MODE_BUNDLE_HANDLE : '',
        max_sets: 1,
        expires_at: expiresAt,
        activation: {
          status: 'active',
          code: 'TARA-PREVIEW',
          expires_at: expiresAt,
        },
      },
      care_protocol: {
        entry_point: 'full_routine',
        intensive_phase: 'Use the complete routine consistently during the first four weeks.',
        maintenance_phase: 'Continue the core steps as the scalp and lengths stabilize.',
        expected_timeline: 'This copy previews where timing guidance appears in the layout.',
        personalized_note: 'This is editor-only preview content and is not shown as a customer fallback.',
      },
      ingredient_highlights: [
        { name: 'Niacinamide', benefit: 'Supports the look of a calmer, more balanced scalp.' },
        { name: 'Salicylic Acid', benefit: 'Shows where a scalp-clarifying ingredient benefit appears.' },
        { name: 'Cactus Extract', benefit: 'Demonstrates the ingredient-card benefit line.' },
      ],
    };
  }

  function readStoredRecord(isDesignMode, catalogArr, config) {
    if (isDesignMode) {
      return {
        assessment: getDesignModeSampleResult(catalogArr, config),
        store: null,
        contact: null,
      };
    }

    try {
      const session = window.TaraConsultationSession || null;
      const record = session && typeof session.readAssessmentRecord === 'function'
        ? session.readAssessmentRecord()
        : null;

      if (!record) return null;
      if (record && typeof record !== 'object') {
        return {
          assessment: record,
          store: null,
          contact: null,
        };
      }

      const assessment = record.assessment || record.profile || record;
      const contact = window.TaraConsultationStore
        ? window.TaraConsultationStore.normalizeContactSnapshot(record.contact || (assessment && assessment.contact))
        : null;

      return {
        assessment,
        store: record.store && window.TaraConsultationStore
          ? window.TaraConsultationStore.buildStorePayload(record.store)
          : null,
        contact,
      };
    } catch (error) {
      console.error('[Tara Consultation] Error reading assessment:', error);
      captureMonitoringException(error, {
        error_code: 'results_record_read_failed',
        level: 'error',
        fingerprint: ['tara-consultation', 'results-record-read-failed'],
      });
      return null;
    }
  }

  function normalizeOffer(offer, config, helpers) {
    if (!offer || typeof offer !== 'object' || !helpers) return null;

    const activation = offer.activation && typeof offer.activation === 'object' ? offer.activation : null;
    const topLevelActive = offer.active === true || `${offer.active || ''}`.toLowerCase() === 'true';
    const activationStatus = (activation && activation.status || offer.activation_status || '').toString().trim().toLowerCase();
    const activationCode = (
      (activation && activation.code)
      || offer.code
      || offer.discount_code
      || ''
    ).toString().trim();
    const currency = (offer.currency || (config && config.currency) || 'EUR').toString().trim().toUpperCase();
    const isLive = Boolean((activationStatus === 'active' || topLevelActive) && activationCode);

    return {
      mode: (offer.mode || '').toString().trim(),
      bundleHandle: typeof offer.bundle_handle === 'string' ? offer.bundle_handle.trim() : '',
      maxSets: Number(offer.max_sets) || 0,
      discountPercent: Number(offer.discount_percent) || 0,
      currency,
      referencePrice: Number(offer.reference_price) || 0,
      discountedPrice: Number(offer.discounted_price) || 0,
      savings: Number(offer.savings) || 0,
      referencePriceMinor: helpers.toMinorUnits(offer.reference_price, currency),
      discountedPriceMinor: helpers.toMinorUnits(offer.discounted_price, currency),
      savingsMinor: helpers.toMinorUnits(offer.savings, currency),
      requiredHandles: Array.isArray(offer.required_handles) ? offer.required_handles.filter(Boolean) : [],
      requiredVariantIds: Array.isArray(offer.required_variant_ids)
        ? offer.required_variant_ids.map(function mapVariantId(value) {
          return Number(value);
        }).filter(function filterVariantId(value) {
          return Number.isFinite(value) && value > 0;
        })
        : [],
      expiresAt: typeof offer.expires_at === 'string' ? offer.expires_at : '',
      activation: {
        status: activationStatus || (topLevelActive ? 'active' : ''),
        code: activationCode,
        checkoutUrl: typeof (activation && activation.checkout_url) === 'string'
          ? activation.checkout_url
          : (typeof offer.checkout_url === 'string' ? offer.checkout_url : ''),
        discountUrl: typeof (activation && activation.discount_url) === 'string'
          ? activation.discount_url
          : (typeof offer.discount_url === 'string' ? offer.discount_url : ''),
        createdAt: typeof (activation && activation.created_at) === 'string' ? activation.created_at : '',
        expiresAt: typeof (activation && activation.expires_at) === 'string'
          ? activation.expires_at
          : (typeof offer.expires_at === 'string' ? offer.expires_at : ''),
        reason: typeof (activation && activation.reason) === 'string' ? activation.reason : '',
        isLive,
      },
      isLive,
    };
  }

  function offerMatchesRoutinePurchase(offer, routinePurchase, helpers) {
    if (!offer || !offer.isLive || !routinePurchase || !helpers) return false;

    const offerMode = helpers.normalizeKey(offer.mode || '');
    const routineMode = helpers.normalizeKey(routinePurchase.mode || '');
    if (offerMode && routineMode && offerMode !== routineMode) return false;

    const routineHandles = Array.from(new Set(
      (routinePurchase.addItems || [])
        .map(function mapItem(item) {
          return helpers.normalizeKey(item && item.handle || '');
        })
        .filter(Boolean)
    ));
    const requiredHandles = Array.from(new Set(
      (offer.requiredHandles || [])
        .map(function mapHandle(handle) {
          return helpers.normalizeKey(handle);
        })
        .filter(Boolean)
    ));

    if (routinePurchase.mode === 'bundle_product') {
      const bundleHandle = helpers.normalizeKey(routinePurchase.bundleHandle || (routinePurchase.bundleProduct && routinePurchase.bundleProduct.handle) || '');
      if (requiredHandles.length && (!bundleHandle || !requiredHandles.includes(bundleHandle))) return false;
      if (offer.bundleHandle && bundleHandle && helpers.normalizeKey(offer.bundleHandle) !== bundleHandle) return false;
    }

    if (routinePurchase.mode === 'multi_item' && requiredHandles.length) {
      if (!requiredHandles.every(function everyHandle(handle) { return routineHandles.includes(handle); })) return false;
    }

    if (Array.isArray(offer.requiredVariantIds) && offer.requiredVariantIds.length) {
      const routineVariantIds = new Set(
        (routinePurchase.addItems || [])
          .map(function mapVariant(item) { return Number(item && item.id); })
          .filter(function filterVariant(value) { return Number.isFinite(value) && value > 0; })
      );
      if (!offer.requiredVariantIds.every(function everyVariant(id) { return routineVariantIds.has(id); })) return false;
    }

    return true;
  }

  function buildRoutineSummary(baseSummary, offer, routinePurchase, helpers) {
    const summary = Object.assign({}, baseSummary);
    if (!offerMatchesRoutinePurchase(offer, routinePurchase, helpers)) {
      summary.totalCompareAtPrice = 0;
      summary.discountPercent = 0;
      summary.offerCode = '';
      return summary;
    }

    if (offer.referencePriceMinor > offer.discountedPriceMinor && offer.discountedPriceMinor > 0) {
      summary.currency = offer.currency || summary.currency;
      summary.totalPrice = offer.discountedPriceMinor;
      summary.totalCompareAtPrice = offer.referencePriceMinor;
      summary.savings = offer.savingsMinor;
      summary.discountPercent = offer.discountPercent;
      summary.offerCode = offer.activation && offer.activation.code || '';
    } else {
      summary.totalCompareAtPrice = 0;
      summary.discountPercent = 0;
      summary.offerCode = '';
    }

    return summary;
  }

  function buildResultsState(options) {
    const sectionId = options.sectionId;
    const catalogArr = Array.isArray(options.catalogArr) ? options.catalogArr : [];
    const productsByHandle = {};
    catalogArr.forEach(function indexProduct(product) {
      if (product && product.handle) productsByHandle[product.handle] = product;
    });

    const bundleFamilies = options.bundleFamilies || {};
    const config = Object.assign({
      consultationPageUrl: options.parsedConfig && options.parsedConfig.consultationPageUrl || '/pages/consulta-capilar',
    }, options.parsedConfig || {});
    config.i18n = decodeI18nMap(config.i18n);
    const helpers = options.helpers;

    Object.entries(bundleFamilies).forEach(function attachBundleFamily(entry) {
      const bundleHandle = entry[0];
      const children = entry[1];
      if (productsByHandle[bundleHandle]) {
        productsByHandle[bundleHandle].bundle_components = children;
      }
    });

    const isDesignMode = !!options.isDesignMode;
    const useDesignModeSample = isDesignMode && config.showEditorDemoData !== false;
    const storedRecord = readStoredRecord(useDesignModeSample, catalogArr, config);
    const assessment = storedRecord && storedRecord.assessment || null;
    const publicStore = config.store && window.TaraConsultationStore
      ? window.TaraConsultationStore.buildStorePayload(config.store)
      : (config.store || null);
    const session = {
      store: storedRecord && storedRecord.store || publicStore,
      contact: storedRecord && storedRecord.contact || null,
    };

    if (!assessment) {
      return {
        ready: true,
        empty: true,
        designMode: isDesignMode,
        bridgeSectionId: sectionId,
        config: Object.assign({}, config, { store: session.store }),
        session,
      };
    }

    const recommendations = Array.isArray(assessment.recommended_products)
      ? assessment.recommended_products
      : [];
    const liveOffer = normalizeOffer(assessment.offer, config, helpers);
    const allProducts = [];

    recommendations.forEach(function attachRecommendation(recommendation) {
      if (productsByHandle[recommendation && recommendation.handle]) {
        allProducts.push(Object.assign({}, recommendation, {
          product: productsByHandle[recommendation.handle],
        }));
      } else if (recommendation && recommendation.handle) {
        console.warn(`[Tara Consultation] Recommended handle "${recommendation.handle}" not found in catalog`);
      }
    });

    const routinePurchaseOption = assessment.routine_purchase_option || null;
    let routinePurchase = null;

    if (routinePurchaseOption && ['bundle_product', 'multi_item'].includes(routinePurchaseOption.mode)) {
      const displayHandles = Array.isArray(routinePurchaseOption.product_handles)
        ? routinePurchaseOption.product_handles.filter(Boolean)
        : [];
      const displayProducts = [];
      const unresolvedDisplayHandles = [];

      displayHandles.forEach(function resolveDisplayHandle(handle) {
        const product = productsByHandle[handle];
        if (product) displayProducts.push(product);
        else unresolvedDisplayHandles.push(handle);
      });

      const requestedItems = Array.isArray(routinePurchaseOption.items) ? routinePurchaseOption.items : [];
      const addItems = [];
      const unresolvedCartHandles = [];
      const unavailableCartHandles = [];
      let totalPrice = 0;
      let totalCompareAtPrice = 0;

      requestedItems.forEach(function resolveCartItem(item) {
        const handle = item && item.handle;
        const quantity = Number(item && item.quantity) > 0 ? Number(item.quantity) : 1;
        const product = handle ? productsByHandle[handle] : null;
        const requestedVariantId = Number(item && (item.variant_id || item.variantId || item.id));
        const variantId = Number.isFinite(requestedVariantId) && requestedVariantId > 0
          ? requestedVariantId
          : (product && product.variant_id || null);
        const price = Number(product && product.price) || 0;
        const compareAtPrice = Number(product && product.compare_at_price) || 0;

        if (product && product.available === false) {
          unavailableCartHandles.push(handle);
          return;
        }

        if (variantId) {
          addItems.push({
            id: variantId,
            quantity,
            handle,
          });
          totalPrice += price * quantity;
          totalCompareAtPrice += (compareAtPrice > price ? compareAtPrice : price) * quantity;
        } else if (handle) {
          unresolvedCartHandles.push(handle);
        }
      });

      const i18n = config.i18n || {};
      const titleFallback = routinePurchaseOption.mode === 'multi_item'
        ? i18n.yourRoutine || 'Your Complete Routine'
        : i18n.yourSet || 'Your Recommended Set';
      const buttonFallback = routinePurchaseOption.mode === 'multi_item'
        ? i18n.addRoutine || 'Add Routine to Cart'
        : i18n.addSet || 'Add Set to Cart';

      routinePurchase = {
        mode: routinePurchaseOption.mode,
        title: routinePurchaseOption.title || titleFallback,
        subtitle: routinePurchaseOption.subtitle || '',
        reasoning: routinePurchaseOption.reasoning || '',
        buttonLabel: routinePurchaseOption.button_label || buttonFallback,
        products: displayProducts,
        addItems,
        unresolvedDisplayHandles,
        unresolvedCartHandles,
        unavailableCartHandles,
        disabled: false,
        disabledReason: null,
        bundleHandle: null,
        bundleProduct: null,
        bundleComponents: [],
        offer: liveOffer,
        offerMatched: false,
        summary: {
          currency: (displayProducts[0] && displayProducts[0].currency) || (requestedItems[0] && requestedItems[0].currency) || config.currency || 'EUR',
          productCount: addItems.reduce(function sum(total, item) {
            return total + (Number(item.quantity) || 0);
          }, 0) || displayProducts.length,
          totalPrice,
          totalCompareAtPrice,
        },
      };

      if (routinePurchaseOption.mode === 'bundle_product') {
        const bundleHandle = routinePurchaseOption.bundle_handle || (requestedItems[0] && requestedItems[0].handle) || null;
        const bundleProduct = bundleHandle ? productsByHandle[bundleHandle] : null;
        const configuredBundleItem = addItems.find(function findBundleItem(item) {
          return item.handle === bundleHandle;
        });
        const fallbackBundleItem = bundleProduct && bundleProduct.variant_id && bundleProduct.available !== false
          ? {
            id: bundleProduct.variant_id,
            quantity: 1,
            handle: bundleHandle,
          }
          : null;
        const bundleComponents = displayProducts.length
          ? displayProducts
          : (Array.isArray(bundleFamilies[bundleHandle])
            ? bundleFamilies[bundleHandle].map(function mapHandle(handle) {
              return productsByHandle[handle];
            }).filter(Boolean)
            : []);

        routinePurchase.bundleHandle = bundleHandle;
        routinePurchase.bundleProduct = bundleProduct || null;
        routinePurchase.bundleComponents = bundleComponents;
        routinePurchase.addItems = configuredBundleItem ? [configuredBundleItem] : (fallbackBundleItem ? [fallbackBundleItem] : []);
        routinePurchase.summary = {
          currency: bundleProduct && bundleProduct.currency || routinePurchase.summary.currency,
          productCount: bundleComponents.length,
          totalPrice: Number(bundleProduct && bundleProduct.price) || 0,
          totalCompareAtPrice: 0,
        };
        routinePurchase.disabled =
          !bundleProduct
          || bundleProduct.available === false
          || !routinePurchase.addItems.length
          || unresolvedCartHandles.length > 0
          || unavailableCartHandles.length > 0;
        routinePurchase.disabledReason = routinePurchase.disabled ? 'availability' : null;

        if (bundleHandle && !bundleProduct) {
          console.warn(`[Tara Consultation] routine_purchase_option bundle_handle "${bundleHandle}" not found in catalog`);
        }
      } else {
        routinePurchase.disabled =
          !routinePurchase.addItems.length
          || unresolvedDisplayHandles.length > 0
          || unresolvedCartHandles.length > 0
          || unavailableCartHandles.length > 0;
        routinePurchase.disabledReason = routinePurchase.disabled ? 'availability' : null;
      }

      routinePurchase.offerMatched = offerMatchesRoutinePurchase(
        liveOffer,
        routinePurchase,
        helpers
      );

      routinePurchase.summary = buildRoutineSummary(
        routinePurchase.summary,
        liveOffer,
        routinePurchase,
        helpers
      );
    }

    return {
      ready: true,
      empty: false,
      designMode: isDesignMode,
      bridgeSectionId: sectionId,
      assessment,
      productsByHandle,
      allProducts,
      bundleFamilies,
      routinePurchase,
      offer: liveOffer,
      session,
      config: Object.assign({}, config, {
        store: session.store,
      }),
    };
  }

  window.TaraConsultationResultsState = Object.freeze({
    getOrCreateStore,
    publishState,
    captureMonitoringException,
    captureMonitoringMessage,
    buildResultsState,
    getDesignModeSampleResult,
  });
})();
